<div class="wrapper-header">
  <ui-page-header [showBackButton]="false">Bestellbestätigung</ui-page-header>
  <ui-delivery-windows-dialog [refDate]="deliveryWindowsRefDate()"></ui-delivery-windows-dialog>
</div>

<div class="wrapper-confirmation">
  <ui-order-confirmation></ui-order-confirmation>
</div>

<div class="wrapper-details">
  <h6>Bestelldetails</h6>

  @if (customer(); as customer) {
    <ui-checkout-details [orderCustomReferenceText]="orderCustomReferenceText()" [deliveryDate]="deliveryDate()" [customer]="customer"></ui-checkout-details>
  }

  <ui-button buttonStyle="outlined" [routerLink]="'/'">Zurück zur Startseite</ui-button>
</div>